// segway specific screensizes. These should be used with limited use and
// `import { screenSizes } from '@shipt/design-system-themes'` should be used in almost all cases
export const segwayScreenSizes = {
  lgTablet: '(min-width: 1080px)',
  max_lgTablet: '(max-width: 1079px)',
} as const

export const lgTabletBreakpoint = 1080
